import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const trueRegex = /^(true|1|yes|on)$/i;

export function parseBool(val: string): boolean {
  return trueRegex.test(val);
}
